/** Registre dynamique type → composant React (GenUI). */

const registry = new Map();

/**
 * @param {string} type
 * @param {React.ComponentType<any>} Component
 */
export function registerComponent(type, Component) {
  if (!type || !Component) return;
  registry.set(type, Component);
}

/**
 * @param {string} type
 * @returns {React.ComponentType<any> | null}
 */
export function getRegisteredComponent(type) {
  return registry.get(type) || null;
}

export function getRegisteredTypes() {
  return Array.from(registry.keys());
}
